import React from "react";
import Grid from "@mui/material/Grid2";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

const teamColors: { [id: string]: string[] } = {
  TBR: ["#02285C", "#90BDE7", "#FFFFFF"],
  BAL: ["#F25D23", "#000000", "#FFFFFF"],
  NYY: ["#132448", "#FFFFFF", "#FFFFFF"],
  BOS: ["#BD3039", "#0D2B56", "#FFFFFF"],
  TOR: ["#134A8E", "#E8291C", "#FFFFFF"],
  CLE: ["#E31937", "#002B5C", "#FFFFFF"],
  KCR: ["#004687", "#FFFFFF", "#FFFFFF"],
  DET: ["#0C2C56", "#FFFFFF", "#FFFFFF"],
  CHW: ["#000000", "#BFBFBF", "#FFFFFF"],
  MIN: ["#091F40", "#E31E34", "#FFFFFF"],
  HOU: ["#002D62", "#F4911E", "#FFFFFF"],
  SEA: ["#005C5C", "#0C2C56", "#FFFFFF"],
  TEX: ["#C0111F", "#003278", "#FFFFFF"],
  LAA: ["#BA0021", "#003263", "#C4CED4"],
  ATH: ["#00342C", "#FFB400", "#FFFFFF"],
  WSN: ["#AB0003", "#FFFFFF", "#FFFFFF"],
  NYM: ["#F75500", "#002C6E", "#FFFFFF"],
  MIA: ["#019CD6", "#E51829", "#FFFFFF"],
  PHI: ["#C21D39", "#01396F", "#FFFFFF"],
  ATL: ["#D3042B", "#001D3D", "#FFFFFF"],
  CIN: ["#C6011F", "#000000", "#FFFFFF"],
  PIT: ["#F7BF02", "#000000", "#FFFFFF"],
  CHC: ["#123581", "#E62F2E", "#FFFFFF"],
  MIL: ["#18294C", "#FEC430", "#FFFFFF"],
  STL: ["#BE0A15", "#FDDB00", "#FFFFFF"],
  LAD: ["#005A9D", "#FFFFFF", "#FFFFFF"],
  ARI: ["#C71128", "#00C2CE", "#FFFFFF"],
  SDP: ["#2D221C", "#FFC125", "#FFFFFF"],
  SFG: ["#231F20", "#F4793E", "#E8D8C4"],
  COL: ["#503E80", "#BFC2C9", "#FFFFFF"],
  FA: ["#BFBFBF", "#FFFFFF", "#FFFFFF"],
};

export default function StatCard({
  playerDataProp,
  playerInfoProp,
  isDesktop,
  season
}: {
  playerDataProp: any;
  playerInfoProp: any;
  isDesktop: boolean;
  season: any;
}) {
  //console.log("PDP: ", playerDataProp);
  //console.log("SSP", seasonStatProp)
  //console.log(Object.keys(seasonStatProp))
  //console.log(seasonStatProp["wRC+"])

  return (
    <div>
      {playerInfoProp !== undefined && (
        <Paper
                          sx={{
                            maxWidth: "90vw",
                            height: isDesktop ? (playerDataProp.Position !== "P" ? "100%" : "750px") : "100%" ,
                            width: 500,
                            border: "#293241 solid 2px",
                            boxShadow:
                              "1px 1px 1px black,2px 2px 1px white,3px 3px 1px black,4px 4px 3px",
                          }}
                          square
                          variant="outlined"
                        >
          <div
            style={{
              padding: "10px",
              backgroundColor:
                playerDataProp && playerDataProp.MLB_AbbName !== null
                  ? teamColors[playerDataProp.MLB_AbbName][0]
                  : teamColors["FA"][0],
            }}
          >
            {isDesktop &&
              (<Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Typography variant="h5">
                  <span
                    style={{
                      color:
                        playerDataProp.MLB_AbbName !== null
                          ? teamColors[
                          playerDataProp.MLB_AbbName
                          ][1]
                          : teamColors["FA"][1],
                      fontWeight: "bold",
                      fontSize: "25pt",
                      textAlign: "center"
                    }}
                  >
                    {season} Spring Training Stats
                  </span>
                </Typography>
              </Grid>)}
            {!isDesktop &&
              (<Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
              ><Typography variant="h5" style={{ fontSize: "25pt" }}>
                  <div
                    style={{
                      color:
                        playerDataProp.MLB_AbbName !== null
                          ? teamColors[
                          playerDataProp.MLB_AbbName
                          ][1]
                          : teamColors["FA"][1],
                      fontWeight: "bold",
                    }}
                  >
                    {season} Spring Training Stats
                  </div>
                </Typography></Grid>)}
          </div>
          <div style={{ margin: "10px" }}>
            {(playerDataProp.Position !== "P") && (

              // AB PA BA H 1B 2B 3B HR R RBI BB K
              // BB% K% BB/K AVG OBP SLG OPS ISO Spd BABIP WOBA
              // EV LA Barrels HH% Chase% Whiff% xBA xOBP xSLG xWOBA

              <div>
                <Typography variant="h5" style={{ fontSize: "20pt", marginLeft: "10px" }}>
                  Standard
                </Typography>
                <TableContainer component={Paper} >
                  <Table size="small" padding="none" sx={{ marginLeft: "10px", maxWidth: "95%", marginTop: "5px", marginBottom: "15px" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >AB</TableCell>
                        <TableCell >PA</TableCell>
                        <TableCell >BA</TableCell>
                        <TableCell >H</TableCell>
                        <TableCell >1B</TableCell>
                        <TableCell >2B</TableCell>
                        <TableCell >3B</TableCell>
                        <TableCell >HR</TableCell>
                        <TableCell >BB</TableCell>
                        <TableCell >K</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={"standard"}
                      >
                        <TableCell >{playerDataProp.ab}</TableCell>
                        <TableCell >{playerDataProp.pa}</TableCell>
                        <TableCell >{(playerDataProp.ba).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{playerDataProp.hits}</TableCell>
                        <TableCell >{playerDataProp.singles}</TableCell>
                        <TableCell >{playerDataProp.doubles}</TableCell>
                        <TableCell >{playerDataProp.triples}</TableCell>
                        <TableCell >{playerDataProp.hr}</TableCell>
                        <TableCell >{playerDataProp.bb}</TableCell>
                        <TableCell >{playerDataProp.k}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Typography variant="h5" style={{ fontSize: "20pt", marginLeft: "10px", marginTop: "20px" }}>
                  Advanced
                </Typography>
                <TableContainer component={Paper} >
                  <Table size="small" padding="none" sx={{ width: "95%", marginLeft: "10px", marginTop: "5px", marginBottom: "15px" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >BB%</TableCell>
                        <TableCell >K%</TableCell>
                        <TableCell >BB/K</TableCell>
                        <TableCell >BA</TableCell>
                        <TableCell >OBP</TableCell>
                        <TableCell >SLG</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody >
                      <TableRow
                        key={"advanced"}
                      >
                        <TableCell >{playerDataProp.bbrate}</TableCell>
                        <TableCell >{playerDataProp.krate}</TableCell>
                        <TableCell >{(playerDataProp.bb / playerDataProp.k).toFixed(2)}</TableCell>
                        <TableCell >{(playerDataProp.ba).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{(playerDataProp.obp).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{(playerDataProp.slg).toFixed(3).toString().substring(1)}</TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell >OPS</TableCell>
                        <TableCell >ISO</TableCell>
                        <TableCell >Spd</TableCell>
                        <TableCell >BABIP</TableCell>
                        <TableCell >wOBA</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={"advanced"}
                      >
                        <TableCell >{(playerDataProp.obp + playerDataProp.slg).toString()[0] === '0' ? (playerDataProp.obp + playerDataProp.slg).toFixed(3).toString().substring(1) : (playerDataProp.obp + playerDataProp.slg).toFixed(3).toString() }</TableCell>
                        <TableCell >{(playerDataProp.slg - playerDataProp.ba).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{(playerDataProp.spd).toFixed(2)}</TableCell>
                        <TableCell >{(playerDataProp.babip).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{(playerDataProp.woba).toFixed(3).toString().substring(1)}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Typography variant="h5" style={{ fontSize: "20pt", marginLeft: "10px", marginTop: "20px" }}>
                  Statcast
                </Typography>
                <TableContainer component={Paper} >
                  <Table size="small" padding="none" sx={{ width: "95%", marginLeft: "10px", marginTop: "5px", marginBottom: "15px" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >EV</TableCell>
                        <TableCell >LA</TableCell>
                        <TableCell >Brls</TableCell>
                        <TableCell >HH%</TableCell>
                        <TableCell >Chase%</TableCell>
                        <TableCell >Whiff%</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={"statcast"}
                      >
                        <TableCell >{playerDataProp.ev}</TableCell>
                        <TableCell >{playerDataProp.langle}</TableCell>
                        <TableCell >{playerDataProp.barrels}</TableCell>
                        <TableCell >{playerDataProp.hhrate}</TableCell>
                        <TableCell >{playerDataProp.chaserate.toFixed(2)}</TableCell>
                        <TableCell >{playerDataProp.whiffrate}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>

            )}
            {(playerDataProp.Position === "P") && (
              <div>
                <Typography variant="h5" style={{ fontSize: "20pt", marginLeft: "10px" }}>
                  Standard
                </Typography>
                <TableContainer component={Paper} >
                  <Table size="small" padding="none" sx={{ marginLeft: "10px", maxWidth: "95%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >AB</TableCell>
                        <TableCell >PA</TableCell>
                        <TableCell >BA</TableCell>
                        <TableCell >H</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={"standard"}
                      >
                        <TableCell >{playerDataProp.ab}</TableCell>
                        <TableCell >{playerDataProp.pa}</TableCell>
                        <TableCell >{(playerDataProp.ba).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{playerDataProp.hits}</TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell >1B</TableCell>
                        <TableCell >2B</TableCell>
                        <TableCell >3B</TableCell>
                        <TableCell >HR</TableCell>
                        <TableCell >BB</TableCell>
                        <TableCell >K</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={"standard"}
                      >
                        <TableCell >{playerDataProp.singles}</TableCell>
                        <TableCell >{playerDataProp.doubles}</TableCell>
                        <TableCell >{playerDataProp.triples}</TableCell>
                        <TableCell >{playerDataProp.hr}</TableCell>
                        <TableCell >{playerDataProp.bb}</TableCell>
                        <TableCell >{playerDataProp.k}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Typography variant="h5" style={{ fontSize: "20pt", marginLeft: "10px", marginTop: "20px" }}>
                  Advanced
                </Typography>
                <TableContainer component={Paper} >
                  <Table size="small" padding="none" sx={{ width: "95%", marginLeft: "10px", marginTop: "5px", marginBottom: "15px" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >BB%</TableCell>
                        <TableCell >K%</TableCell>
                        <TableCell >BB/K</TableCell>
                        <TableCell >BA</TableCell>
                        <TableCell >BABIP</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={"advanced"}
                      >
                        <TableCell >{playerDataProp.bbrate}</TableCell>
                        <TableCell >{playerDataProp.krate}</TableCell>
                        <TableCell >{(playerDataProp.bb / playerDataProp.k).toFixed(2)}</TableCell>
                        <TableCell >{(playerDataProp.ba).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{(playerDataProp.babip).toFixed(3).toString().substring(1)}</TableCell>
                      </TableRow>
                    </TableBody>
                    <TableHead>
                      <TableRow>
                        <TableCell >OBP</TableCell>
                        <TableCell >SLG</TableCell>
                        <TableCell >OPS</TableCell>
                        <TableCell >ISO</TableCell>
                        
                        <TableCell >wOBA</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={"advanced"}
                      >
                        <TableCell >{(playerDataProp.obp).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{(playerDataProp.slg).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{(playerDataProp.obp + playerDataProp.slg).toFixed(3).toString().substring(1)}</TableCell>
                        <TableCell >{(playerDataProp.slg - playerDataProp.ba).toFixed(3).toString().substring(1)}</TableCell>
                        
                        <TableCell >{(playerDataProp.woba).toFixed(3).toString().substring(1)}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Typography variant="h5" style={{ fontSize: "20pt", marginLeft: "10px", marginTop: "20px" }}>
                  Statcast
                </Typography>
                <TableContainer component={Paper} >
                  <Table size="small" padding="none" sx={{ width: "95%", marginLeft: "10px", marginTop: "5px", marginBottom: "15px" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell >EV</TableCell>
                        <TableCell >LA</TableCell>
                        <TableCell >Brls</TableCell>
                        <TableCell >HH%</TableCell>
                        <TableCell >Chase%</TableCell>
                        <TableCell >Whiff%</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow
                        key={"statcast"}
                      >
                        <TableCell >{playerDataProp.ev}</TableCell>
                        <TableCell >{playerDataProp.langle}</TableCell>
                        <TableCell >{playerDataProp.barrels}</TableCell>
                        <TableCell >{playerDataProp.hhrate}</TableCell>
                        <TableCell >{playerDataProp.chaserate.toFixed(2)}</TableCell>
                        <TableCell >{playerDataProp.whiffrate}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            )}
          </div>
        </Paper>
      )}
    </div>
  );
}
